/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `CalendarEvent.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { CalendarEvent } from "./CalendarEvent";

import { Audit } from "./Audit";
import { CalendarEventResource } from "./CalendarEventResource";
import { Project } from "./Project";
import { RepeatingCalendarEventDefinition } from "./RepeatingCalendarEventDefinition";
import { Team } from "./Team";
import { User } from "./User";

export type calendarEventType = "unavailability" | "availability";

export const calendarEventTypeValues = { unavailability: 0, availability: 1 };

export abstract class CalendarEventModel {
    id: number;
    actualEndAt: Dayjs | null;
    actualStartAt: Dayjs | null;
    archived: boolean;
    calendarEventType: calendarEventType;
    calendarableId: number | null;
    calendarableType: string | null;
    createdAt: Dayjs;
    createdById: number | null;
    createdByTeamId: number | null;
    description: string | null;
    endAt: Dayjs;
    finalApproved: boolean | null;
    finalApproverId: number | null;
    isTemplate: boolean;
    name: string;
    projectId: number;
    repeatingCalendarEventDefinitionId: number | null;
    startAt: Dayjs;
    updatedAt: Dayjs;
    approved: boolean | null;
    declined: boolean | null;
    status: string | null;
    audits: Audit[] | undefined;
    calendarEventResources: CalendarEventResource[] | undefined;
    createdBy: User | null | undefined;
    createdByTeam: Team | null | undefined;
    finalApprover: User | null | undefined;
    project: Project | null | undefined;
    repeatingCalendarEventDefinition: RepeatingCalendarEventDefinition | null | undefined;
    templateRepeatingCalendarEventDefinition: RepeatingCalendarEventDefinition | null | undefined;
    unacceptedCalendarEventResources: CalendarEventResource[] | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        actualEndAt: Dayjs | null,
        actualStartAt: Dayjs | null,
        archived: boolean,
        calendarEventType: calendarEventType,
        calendarableId: number | null,
        calendarableType: string | null,
        createdAt: Dayjs,
        createdById: number | null,
        createdByTeamId: number | null,
        description: string | null,
        endAt: Dayjs,
        finalApproved: boolean | null,
        finalApproverId: number | null,
        isTemplate: boolean,
        name: string,
        projectId: number,
        repeatingCalendarEventDefinitionId: number | null,
        startAt: Dayjs,
        updatedAt: Dayjs,
        approved: boolean | null,
        declined: boolean | null,
        status: string | null,
        audits: Audit[] | undefined,
        calendarEventResources: CalendarEventResource[] | undefined,
        createdBy: User | null | undefined,
        createdByTeam: Team | null | undefined,
        finalApprover: User | null | undefined,
        project: Project | null | undefined,
        repeatingCalendarEventDefinition: RepeatingCalendarEventDefinition | null | undefined,
        templateRepeatingCalendarEventDefinition: RepeatingCalendarEventDefinition | null | undefined,
        unacceptedCalendarEventResources: CalendarEventResource[] | undefined
    ) {
        this.id = id;
        this.actualEndAt = actualEndAt;
        this.actualStartAt = actualStartAt;
        this.archived = archived;
        this.calendarEventType = calendarEventType;
        this.calendarableId = calendarableId;
        this.calendarableType = calendarableType;
        this.createdAt = createdAt;
        this.createdById = createdById;
        this.createdByTeamId = createdByTeamId;
        this.description = description;
        this.endAt = endAt;
        this.finalApproved = finalApproved;
        this.finalApproverId = finalApproverId;
        this.isTemplate = isTemplate;
        this.name = name;
        this.projectId = projectId;
        this.repeatingCalendarEventDefinitionId = repeatingCalendarEventDefinitionId;
        this.startAt = startAt;
        this.updatedAt = updatedAt;
        this.approved = approved;
        this.declined = declined;
        this.status = status;
        this.audits = audits;
        this.calendarEventResources = calendarEventResources;
        this.createdBy = createdBy;
        this.createdByTeam = createdByTeam;
        this.finalApprover = finalApprover;
        this.project = project;
        this.repeatingCalendarEventDefinition = repeatingCalendarEventDefinition;
        this.templateRepeatingCalendarEventDefinition = templateRepeatingCalendarEventDefinition;
        this.unacceptedCalendarEventResources = unacceptedCalendarEventResources;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): CalendarEvent {
        const newObject = new CalendarEvent(
            json["id"],
            json["actual_end_at"] ? dayjs(json["actual_end_at"]).tz(timezone) : null,
            json["actual_start_at"] ? dayjs(json["actual_start_at"]).tz(timezone) : null,
            json["archived"],
            json["calendar_event_type"],
            json["calendarable_id"],
            json["calendarable_type"],
            dayjs(json["created_at"]).tz(timezone),
            json["created_by_id"],
            json["created_by_team_id"],
            json["description"],
            dayjs(json["end_at"]).tz(timezone),
            json["final_approved"],
            json["final_approver_id"],
            json["is_template"],
            json["name"],
            json["project_id"],
            json["repeating_calendar_event_definition_id"],
            dayjs(json["start_at"]).tz(timezone),
            dayjs(json["updated_at"]).tz(timezone),
            json["approved"],
            json["declined"],
            json["status"],
            json["audits"]?.map((item: any) => Audit.fromApiObject(item, timezone)),
            json["calendar_event_resources"]?.map((item: any) => CalendarEventResource.fromApiObject(item, timezone)),
            json["created_by"] == null ? json["created_by"] : User.fromApiObject(json["created_by"], timezone),
            json["created_by_team"] == null
                ? json["created_by_team"]
                : Team.fromApiObject(json["created_by_team"], timezone),
            json["final_approver"] == null
                ? json["final_approver"]
                : User.fromApiObject(json["final_approver"], timezone),
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone),
            json["repeating_calendar_event_definition"] == null
                ? json["repeating_calendar_event_definition"]
                : RepeatingCalendarEventDefinition.fromApiObject(json["repeating_calendar_event_definition"], timezone),
            json["template_repeating_calendar_event_definition"] == null
                ? json["template_repeating_calendar_event_definition"]
                : RepeatingCalendarEventDefinition.fromApiObject(
                      json["template_repeating_calendar_event_definition"],
                      timezone
                  ),
            json["unaccepted_calendar_event_resources"]?.map((item: any) =>
                CalendarEventResource.fromApiObject(item, timezone)
            )
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            actual_end_at: this.actualEndAt,
            actual_start_at: this.actualStartAt,
            archived: this.archived,
            calendar_event_type: this.calendarEventType,
            calendarable_id: this.calendarableId,
            calendarable_type: this.calendarableType,
            created_at: this.createdAt,
            created_by_id: this.createdById,
            created_by_team_id: this.createdByTeamId,
            description: this.description,
            end_at: this.endAt,
            final_approved: this.finalApproved,
            final_approver_id: this.finalApproverId,
            is_template: this.isTemplate,
            name: this.name,
            project_id: this.projectId,
            repeating_calendar_event_definition_id: this.repeatingCalendarEventDefinitionId,
            start_at: this.startAt,
            updated_at: this.updatedAt,
            audits: this.audits?.map((item) => item.toApiObject(visited)).filter((item) => item !== undefined),
            calendar_event_resources_attributes: this.calendarEventResources
                ?.map((item) => item.toApiObject(visited))
                .filter((item) => item !== undefined),
            created_by_attributes: this.createdBy?.toApiObject(visited),
            created_by_team_attributes: this.createdByTeam?.toApiObject(visited),
            final_approver_attributes: this.finalApprover?.toApiObject(visited),
            project_attributes: this.project?.toApiObject(visited),
            repeating_calendar_event_definition_attributes: this.repeatingCalendarEventDefinition?.toApiObject(visited),
            template_repeating_calendar_event_definition_attributes:
                this.templateRepeatingCalendarEventDefinition?.toApiObject(visited),
            unaccepted_calendar_event_resources: this.unacceptedCalendarEventResources
                ?.map((item) => item.toApiObject(visited))
                .filter((item) => item !== undefined),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): CalendarEvent {
        const clone = Object.create(this) as CalendarEvent;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
